let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fyKC8")).then(() => parcelRequire('9mzj0'));